import React, { useState, useEffect } from "react";
import { AgChartsReact } from "ag-charts-react";
import { server } from "../../App";
import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import {
  YearsOptions,
  MonthsOptions,

} from "../Consultation/bloc3/DropdownOptions/AvOptions";
import { Form, Dropdown } from "semantic-ui-react";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"


function Weeks() {
  const [Year, setYear] = useState(moment().format("YYYY"));
  const [Month, setMonth] = useState(moment().format("MM"));
  const [fk_id_medecin1, setfk_id_medecin1] = useState(0);
  const Doctors = useGetDoctorsSemanticUI()

  let myObject = { key: "0000000A", text: "Global", value: 0 }
  let myObject2 = Doctors?.Doctors_list ? Doctors?.Doctors_list : []

  myObject2.push(myObject)

  const getData = () => {
    let url;
    // DEV
    // if (fk_id_medecin1 == 0) {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByWeek/${Year}/${Month}`;
    // } else {
    //   url = `${server}AnnualRevenu/StatisticsRoutes/GetRevenuByWeek/${Year}/${Month}/${fk_id_medecin1}`;
    // }

    // PROD
    if (fk_id_medecin1 == 0) {
      url = `${server}StatisticsRoutes/GetRevenuByWeek/${Year}/${Month}`;
    } else {
      url = `${server}StatisticsRoutes/GetRevenuByWeek/${Year}/${Month}/${fk_id_medecin1}`;
    }


    return axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => response.data);
  };
  const { data, refetch } = useQuery("Weeks", () => {
    return getData();
  });

  useEffect(() => {
    refetch();
  }, [Month, Year, fk_id_medecin1]);

  let options = {
    title: {
      text: "Revenu hébdomadaire du centre",
    },
    subtitle: {
      text: "En Dirham",
    },
    data: data,
    series: [
      {
        type: "column",
        xKey: "Semaine",
        yKeys: ["Total"],
      },
    ],
    legend: {
      position: 'bottom',
    },
  };

  return (
    <>
      <div className="FixingAbigProblem">


        <Form.Field
          className="TinySelect2"
          value={Year}
          search
          selection
          fluid
          label="Année"
          control={Dropdown}
          options={YearsOptions}
          placeholder="Année"
          onChange={(e, data) => {
            setYear(data.value);
          }}
        />

        <Form.Field
          className="TinySelect2"
          value={Month}
          search
          selection
          fluid
          label="Mois"
          control={Dropdown}
          options={MonthsOptions}
          placeholder="Mois"
          onChange={(e, data) => {
            setMonth(data.value);
          }}
        />
        <Form.Field
          // className="TinySelect2"
          value={fk_id_medecin1}
          search
          selection
          fluid
          label="Médecin"
          control={Dropdown}
          options={myObject2}
          // placeholder="Médecin"
          onChange={(e, data) => {
            setfk_id_medecin1(data.value);
          }}
        />
      </div>
      <AgChartsReact options={options} />
    </>
  );
}

export default Weeks;
